/*****************************
画像や、ファイルの読み込みによるプログレスバー

2016/12/05 ver 1.2.0	読み込み部分を別ライブラリに分けた
						onError() を用意した
2016/05/27 ver 1.1.1	違うhostnameのものは弾くようにした
2016/05/24 ver 1.1	onProgress() に urlを追加
						add_urls() を追加
2016/05/20 ver 1.0	とりあえず作成
*/

/* [javascript] *********************************
var $progress_bar = $('#fadein .fadein__progress');
var CaracolLoadProgress = require('./caracol/util/jquery.load_progress.js');

var progress = new CaracolLoadProgress({
	onProgress: function( total, count, percent ){
		$progress_bar.css({ width: (percent * 100)+'%' });
	},
	onComplete: function( total, count ){
		$progress_bar.css({ width: '100%' });
		setTimeout( function(){ $('#fadein').remove(); }, 1700);
	}
});
progress.start();
***********************************/

/* [補足] *********************************
progress.add_urls( array );

自動的に <img src="〜"> <image src="〜"> を読み込み対象とするが、
それ以外に読み込みに追加したいファイルを配列で指定。
***********************************/



var CaracolLoadProgress;

module.exports = CaracolLoadProgress = function( config ){
	'use strict';

	var defaults = {
		onProgress: function( total, count, percent ){},
		onComplete: function( total, count ){},
		onError: function( url, jqXHR, textStatus, errorThrown ){},
		urls: []
	}
	this.opt = jQuery.extend( defaults, config );
	this.urls = this.opt.urls;
	this.total = 0;
}
/***************************
* add url
*/
CaracolLoadProgress.prototype.add_urls = function( list ){
	'use strict';
	this.urls = this.urls.concat( list );
}
/***************************
* start
*/
CaracolLoadProgress.prototype.start = function(){
	'use strict';

	var self = this;
	// var count = 0;
	var finished = [];

	// 画像を数える
	this.checkImageTags();

	// 画像他をプリロード
	var preload = require('./preload.js');
	preload( this.urls, {
		onProgress: function( url, total, count, percent ){
			self.opt.onProgress( total, count, percent, url );
			finished.push( url );
		}
	})
	.fail( function( url, jqXHR, textStatus, errorThrown ){
		self.opt.onError( url, jqXHR, textStatus, errorThrown );
	})
	.done( function( total, count  ){
		// 全部読み終わった
		self.opt.onComplete( total, count );
	});

	// // 個々のURLを取得し、deferredオブジェクトを返す
	// var promise = this.urls.map( function( url ){
	// 	// console.log(url);
	// 	return jQuery.get( url )
	// 	.then( function( e ){
	// 		var percent = ( count +1 ) / self.total;
	// 		self.opt.onProgress( self.total, count, percent, url );
	// 		finished.push( url );
	// 		count ++;
	// 	});
	// });

	// // 全部読み込み終わったら実行
	// jQuery.when.apply( null, promise )
	// .done( function(){
	// 	self.opt.onComplete( self.total, count );
	// });

	// // 3秒後に読み込めなかったURLを表示
	// setTimeout( function(){
	// 	for( var i=0; i<self.urls.length; i++ ){
	// 		var url = self.urls[i];
	// 		// 終了リストに存在しない
	// 		if( $.inArray( url, finished ) < 0 ){
	// 			console.log("[load error]",url);
	// 		}
	// 	}
	// }, 3000 );

}

/***************************
* check <img> tags
*/
CaracolLoadProgress.prototype.checkImageTags = function(){
	'use strict';

	var hostname = /^https?:\/\/[^\/]+\//.exec( window.location.href )[0];
	var imgs = document.getElementsByTagName('img');
	var images = document.getElementsByTagName('image');
	var length;
	var i;

	// <img>
	length = imgs.length;
	if( length ){
		for( i=0; i<length; i++ ){
			// 違うホストのものは弾く
			if( imgs[i].src.indexOf(hostname) === 0 ){
				this.urls.push( imgs[i].src );
			}
		}
	}

	// SVGの<image>
	length = images.length;
	if( length ){
		for( i=0; i<length; i++ ){
			// 違うホストのものは弾く
			if( images[i].src.indexOf(hostname) === 0 ){
				this.urls.push( images[i].src );
			}
		}
	}

	this.total = this.urls.length;
}

